import { useEffect, useState } from 'react';
import { Tag, Tooltip } from 'antd';
import { SyncOutlined, CheckCircleOutlined } from '@ant-design/icons';
import { useLocalProducts } from '~/hooks';
import './SyncStatus.scss';
import {Button} from "../../../components";

/**
 * Component hiển thị trạng thái sync IndexedDB
 */
function SyncStatus() {
    const { isReady, isSyncing, syncStatus, syncProducts } = useLocalProducts();
    const [lastSyncText, setLastSyncText] = useState('');

    useEffect(() => {
        if (syncStatus?.syncTime) {
            const updateLastSync = () => {
                const now = Date.now();
                const syncTime = syncStatus.syncTime * 1000;
                const diff = now - syncTime;

                if (diff < 60000) {
                    setLastSyncText('Vừa xong');
                } else if (diff < 3600000) {
                    const minutes = Math.floor(diff / 60000);
                    setLastSyncText(`${minutes} phút trước`);
                } else if (diff < 86400000) {
                    const hours = Math.floor(diff / 3600000);
                    setLastSyncText(`${hours} giờ trước`);
                } else {
                    const days = Math.floor(diff / 86400000);
                    setLastSyncText(`${days} ngày trước`);
                }
            };

            updateLastSync();
            const interval = setInterval(updateLastSync, 60000); // Update every minute

            return () => clearInterval(interval);
        }
    }, [syncStatus?.syncTime]);

    const handleManualSync = async () => {
        if (!isSyncing) {
            await syncProducts();
        }
    };

    if (!isReady) {
        return (
            <Tag icon={<SyncOutlined spin />} color="processing">
                Đang tải...
            </Tag>
        );
    }

    const tooltipContent = (
        <div>
            <div>Sản phẩm: {syncStatus?.count || 0}</div>
            {lastSyncText && <div>Đồng bộ: {lastSyncText}</div>}
            <div style={{ marginTop: 4, fontSize: 11 }}>Click để đồng bộ lại</div>
        </div>
    );

    return (
        <Tooltip title={tooltipContent}>
            <Button
                background
                small
                leftIcon={isSyncing ? <SyncOutlined spin /> : <CheckCircleOutlined />}
                green={!isSyncing}
                blue={!!isSyncing}
                onClick={handleManualSync}
                style={{ cursor: 'pointer' }}
                className="sync-status-tag"
            ></Button>
        </Tooltip>
    );
}

export default SyncStatus;
